module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"add-order-item":"Add Order Item"}}')
  delete Component.options._Ctor
}
